import { BASE_INFO_FIELD_KEY_LIST } from '../../capabilities/base-info/fieldKeys';
import { COMPUTE_FIELD_KEY_LIST } from '../../capabilities/compute/fieldKeys';
import { DNS_FIELD_KEY_LIST } from '../../capabilities/dns/fieldKeys';
import { IMAGE_VM_FIELD_KEY_LIST } from '../../capabilities/image-vm/fieldKeys';
import { NETWORK_FIELD_KEY_LIST } from '../../capabilities/network/fieldKeys';
import { RUN_POLICY_FIELD_KEY_LIST } from '../../capabilities/run-policy/fieldKeys';
import { SERVICE_FIELD_KEY_LIST } from '../../capabilities/service/fieldKeys';
import { STORAGE_FIELD_KEY_LIST } from '../../capabilities/storage/fieldKeys';

export const VM_FIELD_KEYS = [
  ...BASE_INFO_FIELD_KEY_LIST,
  ...NETWORK_FIELD_KEY_LIST,
  ...RUN_POLICY_FIELD_KEY_LIST,
  ...IMAGE_VM_FIELD_KEY_LIST,
  ...SERVICE_FIELD_KEY_LIST,
  ...COMPUTE_FIELD_KEY_LIST,
  ...STORAGE_FIELD_KEY_LIST,
  ...DNS_FIELD_KEY_LIST,
] as const;

export type VmFieldKey = (typeof VM_FIELD_KEYS)[number];
